import { requestWithToken as request } from "./api";

const BASE = "/financial-reports";

function buildQuery(params) {
    const entries = Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== ""
    );
    if (entries.length === 0) return "";
    const qs = entries
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join("&");
    return `?${qs}`;
}

// Generic endpoints — three resource-oriented calls cover every tab.
export function getCategorySummary(category, endDate) {
    return request.get(`${BASE}/${category}/summary/${buildQuery({ end_date: endDate })}`);
}

export function getCategoryBreakdown(category, initDate, endDate, groupBy = "cuentas", period = "month") {
    return request.get(
        `${BASE}/${category}/breakdown/${buildQuery({
            init_date: initDate,
            end_date: endDate,
            group_by: groupBy,
            period,
        })}`
    );
}

export function getResultStateByPeriod(period, initDate, endDate) {
    return request.get(
        `${BASE}/state/${buildQuery({ period, init_date: initDate, end_date: endDate })}`
    );
}

// Backwards-compatible wrappers — kept so the 7 Vuex modules don't need to change.
// Each one is a one-line delegation to the generic call above.

export function getSalesByLevel3(initDate, endDate, groupBy, period) {
    return getCategoryBreakdown("sales", initDate, endDate, groupBy, period);
}

export function getSalesSummaryCards(endDate) {
    return getCategorySummary("sales", endDate);
}

export function getExpensesByLevels(initDate, endDate, groupBy, period) {
    return getCategoryBreakdown("expenses", initDate, endDate, groupBy, period);
}

export function getExpensesSummaryCards(endDate) {
    return getCategorySummary("expenses", endDate);
}

export function getCostsByLevels(initDate, endDate, groupBy, period) {
    return getCategoryBreakdown("costs", initDate, endDate, groupBy, period);
}

export function getCostsSummaryCards(endDate) {
    return getCategorySummary("costs", endDate);
}

export function getAssetsByLevels(initDate, endDate, groupBy, period) {
    return getCategoryBreakdown("assets", initDate, endDate, groupBy, period);
}

export function getAssetsSummaryCards(endDate) {
    return getCategorySummary("assets", endDate);
}

export function getNonOperationalByLevels(initDate, endDate, groupBy, period) {
    return getCategoryBreakdown("non-operational", initDate, endDate, groupBy, period);
}

export function getNonOperationalSummaryCards(endDate) {
    return getCategorySummary("non-operational", endDate);
}

export function getProfitabilitySummaryCards(endDate) {
    return getCategorySummary("profitability", endDate);
}

// Sales analysis modal — drill-down de un mes específico.
// `selectedItems` es un dict { tipo: [name, ...] }; se envía JSON-encoded
// en el query param `attribute_filters`. El backend descarta entradas con
// listas vacías, así que filtramos client-side antes de serializar para
// no inflar la URL.
export function getSalesAnalysis(month, account = null, groupBy = null, selectedItems = null) {
    return request.get(
        `${BASE}/sales/analysis/${buildQuery({
            month,
            account,
            group_by: groupBy,
            attribute_filters: serializeAttributeFilters(selectedItems),
        })}`
    );
}

function serializeAttributeFilters(selectedItems) {
    if (!selectedItems) return "";
    const cleaned = Object.entries(selectedItems).reduce((acc, [key, vals]) => {
        if (Array.isArray(vals) && vals.length > 0) acc[key] = vals;
        return acc;
    }, {});
    return Object.keys(cleaned).length > 0 ? JSON.stringify(cleaned) : "";
}
